var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z",
    fill: "#F6892A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 14,
    height: 8,
    rx: 1,
    fill: "#F6892A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 16H11.582V14.895H12.192C12.887 14.895 13.357 14.375 13.357 13.655C13.357 12.935 12.887 12.425 12.192 12.425H10.707V16ZM11.582 14.145V13.175H12.027C12.317 13.175 12.467 13.37 12.467 13.655C12.467 13.94 12.317 14.145 12.012 14.145H11.582Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.876 16H14.751V14.895H15.361C16.056 14.895 16.526 14.375 16.526 13.655C16.526 12.935 16.056 12.425 15.361 12.425H13.876V16ZM14.751 14.145V13.175H15.196C15.486 13.175 15.636 13.37 15.636 13.655C15.636 13.94 15.486 14.145 15.181 14.145H14.751Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7299 16H18.6049V13.175H19.6899V12.425H16.6449V13.175H17.7299V16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePpt);
export default __webpack_public_path__ + "static/media/file_PPT.9d8c426cc3a22329c4481faacbd0da74.svg";
export { ForwardRef as ReactComponent };